import {FETCH_PERSONAL_REQUEST, FETCH_PERSONAL_SUCCES, FETCH_PERSONAL_ERROR} from '../constants/Personal'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function personal(state = initialState, action) {
  switch (action.type) {
      case FETCH_PERSONAL_REQUEST:
        return {...state, isLoading: true};
      case FETCH_PERSONAL_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_PERSONAL_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/personal.js